import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

const setMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel: string, href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function Seo({ title, description, keywords, path, jsonLd }: SeoProps) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    const origin = window.location.origin;
    const canonical = `${origin}${path}`;

    document.title = title;
    document.documentElement.lang = "zh-CN";

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow");

    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "51吃瓜榜");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    setLink("canonical", canonical);

    const existing = document.getElementById("cg-jsonld");
    if (existing) {
      existing.remove();
    }
    if (jsonLdStr) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "cg-jsonld";
      script.textContent = jsonLdStr;
      document.head.appendChild(script);
    }
  }, [title, description, keywords, path, jsonLdStr]);

  return null;
}